/**
 * onTabSelect : pass this func from parent to change the tabNames.
 * tabNames : mandatory to pass this array with names of the tabs.
 * eventKeyName : mandatory to pass event key names for achieving the click of tab and also to know what tab is clicked.
 * activeClasses : to apply the active class for the tabs on onclick.
 * segmentedControlDiv : to apply class for the division the entire tab.
 */

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Nav, NavItem } from 'react-bootstrap';

class SegmentedControl extends React.Component {
  componentDidUpdate(prevProps, prevState) {}

  getNavItem() {
    let tabComponent;
    let tabOptions = [];
    _.map(this.props.tabs, (tab, index) => {
      tab.eventKey === this.props.selectedKey
        ? (tab.activeClass = 'active')
        : (tab.activeClass = '');
      tabComponent = (
        <NavItem eventKey={tab.eventKey} key={index}>
          <span aria-label="Filtered By" /> {tab.tabName}
        </NavItem>
      );
      tabOptions.push(tabComponent);
    });
    return tabOptions;
  }

  render() {
    return (
      <Nav
        bsStyle="pills"
        className="c-nav-pills"
        activeKey={this.props.selectedKey}
        onSelect={this.props.onTabSelect}
      >
        {this.getNavItem()}
      </Nav>
    );
  }
}

SegmentedControl.propTypes = {
  onTabSelect: PropTypes.func.isRequired,
  tabNames: PropTypes.array,
  segmentedControlDiv: PropTypes.string,
  activeClasses: PropTypes.array,
};
SegmentedControl.defaultProps = {
  onTabselect() {
    return null;
  },
  tabNames: ['All', 'Money In', 'Money Out'],
  segmentedControlDiv: 'type--jura segmented-control',
  activeClasses: ['active', '', ''],
  eventKeyName: [1, 2, 3],
};
export default SegmentedControl;
/** order of execution :
 * 1. componentWillMount is called.
 * 2. componentDidMount is called
 * 3. componentWillReceiveProps is called
 * 4. shouldComponentUpdate is called
 * 5. componentWillUpdate
 * 6. componentDidUpdate
 */
